<header>
  <blitz-header></blitz-header>
</header>
<main>
  <blitz-popup-notification></blitz-popup-notification>
  <blitz-centered-popover></blitz-centered-popover>
  <router-outlet></router-outlet>
</main>
<blitz-footer></blitz-footer>
